import apiClient from './apiClient';

export async function getStripeSession(sessionId) {
  console.log(`[getStripeSession] Called with sessionId: ${sessionId}`);

  if (!sessionId) {
    console.warn("[getStripeSession] No sessionId provided. Exiting.");
    return null;
  }
  
  const endpoint = `stripe-webhook/session?session_id=${sessionId}`;
  console.log(`[getStripeSession] Fetching endpoint: ${endpoint}`);

  try {
    // This is a public endpoint, so we pass `true`
    const data = await apiClient.get(endpoint, true);
    console.log("[getStripeSession] Successfully fetched and parsed session data:", data);
    return data;
  } catch (error) {
    console.error("[getStripeSession] An unexpected error occurred during fetch:", error);
    return null;
  }
}